import store from '..';
import { Health } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const { initialState, resetReducer, resetAction } = createRestSlices(Health);

const GET_LAST_HEALTH_CHECK = 'kronos/health/GET_LAST_HEALTH_CHECK';
const GET_LAST_HEALTH_CHECK_SUCCESS = 'kronos/health/GET_LAST_HEALTH_CHECK_SUCCESS';
const GET_LAST_HEALTH_CHECK_FAILURE = 'kronos/health/GET_LAST_HEALTH_CHECK_FAILURE';
const CHECK_HEALTH                  = 'kronos/health/CHECK_HEALTH';
const CHECK_HEALTH_SUCCESS          = 'kronos/health/CHECK_HEALTH_SUCCESS';
const CHECK_HEALTH_FAILURE          = 'kronos/health/CHECK_HEALTH_FAILURE';

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_LAST_HEALTH_CHECK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
                log: null
            };
        case GET_LAST_HEALTH_CHECK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                log: action.log
            };
        case GET_LAST_HEALTH_CHECK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message,
                log: null
            };
        case CHECK_HEALTH:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
                log: null
            };
        case CHECK_HEALTH_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                log: action.log
            };
        case CHECK_HEALTH_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message,
                log: null
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [ resetReducer, reducer ]);
}

function gettingLastHealthCheck() { return { type: GET_LAST_HEALTH_CHECK } }
function gettingLastHealthCheckSuccess(log) { return { type: GET_LAST_HEALTH_CHECK_SUCCESS, log } }
function gettingLastHealthCheckFailure(error) { return { type: GET_LAST_HEALTH_CHECK_FAILURE, error } }
const getLastHealthCheckAction = () => {
    return (dispatch) => {
        dispatch(gettingLastHealthCheck());
        Health.getLastCheck()
            .then(data => {
                const { log } = data;
                dispatch(gettingLastHealthCheckSuccess(log));
            })
            .catch(err => {
                dispatch(gettingLastHealthCheckFailure(err))
            });
    }
};

function checkingHealth() { return { type: CHECK_HEALTH } }
function checkingHealthSuccess(log) { return { type: CHECK_HEALTH_SUCCESS, log } }
function checkingHealthFailure(error) { return { type: CHECK_HEALTH_FAILURE, error } }
const checkHealthAction = () => {
    return (dispatch) => {
        dispatch(checkingHealth());
        Health.check()
            .then(data => {
                const { log } = data;
                dispatch(checkingHealthSuccess(log));
            })
            .catch(err => {
                dispatch(checkingHealthFailure(err))
            });
    }
};

/* Export CRUD actions */
export const resetHealth        = resetAction;
export const getLastHealthCheck = getLastHealthCheckAction;
export const checkHealth        = checkHealthAction;
